import { render } from "./PreLoader.vue?vue&type=template&id=24b3656f&scoped=true"
import script from "./PreLoader.vue?vue&type=script&lang=js"
export * from "./PreLoader.vue?vue&type=script&lang=js"

import "./PreLoader.vue?vue&type=style&index=0&id=24b3656f&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_sindico\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b3656f"]])

export default __exports__